export default {
  nome: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  tipo: {
    value: null,
    options: [
      { value: 1, text: 'CLIENTE' },
      { value: 2, text: 'NÃO CLIENTES' }
    ],
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/campaign/campaignlist/components/add/campaignlistadd-form.js